import styled, { css } from "styled-components";
import { NavLink } from "react-router-dom";
import { rgba } from "polished";

import arrow from "../../assets/images/arrow-right.svg";
import arrowYellow from "../../assets/images/arrow-right-yellow.svg";
import { Panel } from "../Settings/style";
import { Label, SelectboxItem, SelectboxMenu } from "../Selectbox/style";
import arrowDown from "../../assets/images/arrow-down.svg";

export const NavigationBar = styled.div`
  background: linear-gradient(-23deg, ${({ theme }) => theme.colors.color9} 0%, ${({ theme }) => theme.colors.color4} 100%);
  display: ${({ isActive }) => isActive ? "block" : "none"};
  height: 100%;
  margin: 0;
  padding: 100px 0 0;
  position: fixed;
  top: 0;
  width: 455px;
  z-index: 130;
`;

export const NavigationBarSecond = styled(NavigationBar)`
  display: block;
  margin-left: 455px;
`;

export const ItemLink = styled(NavLink)`
  color: ${({ theme }) => theme.colors.color18};
  display: block;
  font-weight: 700;
  padding: 25px 28px;
  position: relative;
  text-decoration: none;

  &:hover {
    color: ${({ theme }) => theme.colors.color15};
  }

  &.active {
    background: ${({ theme }) => theme.colors.color4};
    color: ${({ theme }) => theme.colors.color15};
  }
`;

export const MainItemLink = styled.div`
  color: ${({ theme }) => theme.colors.color18};
  cursor: pointer;
  font-weight: 700;
  padding: 25px 28px;
  position: relative;

  &:hover {
    color: ${({ theme }) => theme.colors.color15};

    &:after {
      background-image: url(${arrowYellow});
    }
  }

  &:after {
    background-image: url(${arrow});
    content: "";
    height: 20px;
    position: absolute;
    right: 28px;
    top: 35px;
    width: 11px;
  }

  ${({ active, theme }) => active && css`
    background: ${theme.colors.color4};
    color: ${theme.colors.color15};

    &:after {
      background-image: url(${arrowYellow});
    }
  `};

`;

export const MenuContainer = styled.ul`
  font-size: 30px;
  list-style-type: none;
  margin: 0;
  padding: 0;
`;

export const MenuItems = styled.li`
  margin-bottom: 1px;
  position: relative;

  &:after {
    border-bottom: 1px solid ${({ theme }) => rgba(theme.colors.color18, 0.35)};
    content: "";
    left: 28px;
    position: absolute;
    width: calc(100% - 56px);
  }

  :last-child:after {
    border-bottom: 0;
  }

  &:hover {
    background: ${({ theme }) => theme.colors.color4};
  }
`;

export const Icon = styled.img`
  margin-right: 9px;
  margin-bottom: -4px;
`;

export const MenuFooter = styled.div`
  bottom: 20px;
  left: 0;
  margin-left: 25px;
  position: absolute;
`;

export const Settings = styled.button`
  color: ${({ theme }) => theme.colors.color18};
  cursor: pointer;
  font-size: 26px;
  font-weight: 700;
  margin-left: 10px;
`;

export const MarketLabel = styled.div`
  background-color: ${({ theme }) => rgba(theme.colors.color20, 0.32)};
  border-radius: 9px;
  display: inline-block;
  float: right;
  font-size: 20px;
  height: 35px;
  line-height: 37px;
  text-align: center;
  text-transform: uppercase;
  width: 91px;
`;

export const Logout = styled.button`
  background: transparent;
  border-radius: 21px;
  border: 1px solid ${({ theme }) => theme.colors.color18};
  color: ${({ theme }) => theme.colors.color18};
  cursor: pointer;
  font-family: "DM Sans";
  font-size: 20px;
  font-weight: 700;
  height: 41px;
  line-height: 1px;
  margin-left: 150px;
  width: 127px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.color27};
    border: 1px solid ${({ theme }) => theme.colors.color1};
  }
`;

export const SettingIcon = styled.img`
  bottom: -7px;
  height: 30px;
  position: relative;
  width: 30px;
`;

export const SettingsWrapper = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  bottom: 0;
  height: 100%;
  left: 0;
  margin: auto;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 300;

  ${Panel} {
    bottom: 80px;
    height: 418px;
    left: 31px;
    top: auto;
  }

  ${SelectboxMenu} {
    background: url(${arrowDown}) center left 10px no-repeat;
    background-size: 13px;
    font-size: 22px;
    transform: rotate(180deg);
  }

  ${Label} {
    transform: rotate(180deg);
  }

  ${SelectboxItem} {
    transform: rotate(180deg);
  }
`;
